export class ClientLogsParams {
    public salesman_ids: Array<string>;
    public client: string;
    public is_in_agenda: boolean;
    public is_active: boolean;
}